<template>
    <div class="score-board-page" :class="dir">
        <header class="fixed-top">
            <nav class="scoring-nav has-background-white">
                <b-button icon-left="chevron-left" type="is-white" size="is-large" @click="goback"></b-button>
                <span v-if="compname" class="is-size-4 scoring-comp-name">{{compname}}</span>
            </nav>
            <transition name="fade">
                <nav v-if="prevroute && prevroute.round" class="live-mini-nav">
                    <span class="live-mini-round">{{prevroute.round}}</span>
                    <span class="live-mini-class">{{prevroute.class}} - {{prevroute.age}}</span>
                    <span v-if="prevroute.elem" class="live-mini-elem">{{prevroute.elem}}</span>
                </nav>
            </transition>
        </header>
        <!--
        <header class="fixed-top">
            <nav class="scoring-nav has-background-white">
                <b-button icon-left="chevron-left" type="is-white" size="is-large" @click="$router.push(`/${compkey}`)"></b-button>
                <span v-if="compname" class="is-size-4 scoring-comp-name">{{compname}}</span>
            </nav>
        </header>
        <header class="fixed-top">
            <nav class="scoring-nav has-background-white">
                <b-button icon-left="chevron-left" type="is-white" size="is-large" @click="$router.push(`/${compkey}/live`)"></b-button>
                <span v-if="compname" class="is-size-4 scoring-comp-name">{{compname}}</span>
            </nav>
            <nav v-if="liveelements" class="live-mini-nav">
                <span :class="{invis: !ready}" class="live-mini-round">{{liveelements.roundLabel}}</span>
                <span :class="{invis: !ready}" class="live-mini-class">{{liveelements.classLabel}} - {{liveelements.ageLabel}}</span>
            </nav>
        </header>
        <header class="fixed-top">
            <nav class="scoring-nav has-background-white">
                <b-button icon-left="chevron-left" type="is-white" size="is-large" @click="$router.push(`/${compkey}/live/${$attrs.racid}`)"></b-button>
                <span v-if="compname" class="is-size-4 scoring-comp-name">{{compname}} {{livescores.scoreMethod}}</span>
            </nav>
            <nav v-if="livescores" class="live-mini-nav">
                <span :class="{invis: !ready}" class="live-mini-round">{{livescores.roundLabel}}</span>
                <span :class="{invis: !ready}" class="live-mini-class">{{livescores.classLabel}} - {{livescores.ageLabel}}</span>
            </nav>
        </header>
        -->
        <template v-if="!loadingcheck" class="competing-back">
            <transition name="slide">
                <router-view v-if="found" :reg="reg" :compkey="key" :compname="compname"></router-view>
            </transition>
            <div v-if="!found" class="container">
                <div class="columns extra-pad pad-fix">
                    <div class="column">
                        <h1 class="home-h1">
                            Sorry, that code<br>didn't work
                        </h1><br>
                        <h2 class="subtitle">
                            Please try again or <router-link to="/" class="button is-text" style="margin-top:-.25rem">Go Back</router-link> 
                        </h2>
                    </div>
                    <div class="column is-one-third has-background-info home-goto-box"> 
                        <goto-box></goto-box>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/*
self register as competitor
view scores
*/
import axios from "axios";
import GotoBox from "../home/GotoBox"
//import FacebookButton from "../login/FacebookButton"
//import GoogleButton from "../login/GoogleButton"
//import MainMenu from "../home/header/MainMenu.vue"


export default {
    name: 'ScoreBoard',
        components: {
            GotoBox,
            //MainMenu,
            //FacebookButton,
            //GoogleButton
        },
    data: function() {
        return {
            reg: false,
            id: null,
            dir: null,
            key: this.$route.params.key,
            found: true,
            loadingcheck: true,
            compname: '',
            action: 'options',
            registernamecheck: false,
            registername: '',
            registertype: '',
            register: { name: '', email: '', checkemail: false, checkname: false, type:'' }
        }
    },
    computed: { 
        prevroute() {
            return this.$store.getters['scoring/prevroute']
        },
        isAuthenticated() {
            return this.$store.getters['account/isAuthenticated']
        },
        competitionCompetitor() {
            if(this.$store && this.$store.state && this.$store.state.scoring && this.$store.state.scoring.scoringscore) {
                let ss = this.$store.state.scoring.scoringscore
                return ss.competitionCompetitor
            } else 
                return null
        }
    },
    mounted() {
        this.checkkey()
    },
    watch: {
        '$route' (to, from) {
            const toDepth = to.path.split('/').length
            const fromDepth = from.path.split('/').length
            this.dir = toDepth < fromDepth ? 'right' : 'left'
        },
        '$route.params.key': function() {
            this.checkkey()
        },
        registername: function(n) {
            if(n && n.length && n.length>1)
                this.registertype='is-success'
            else
                if(this.registernamecheck) 
                    this.registertype='is-danger'
        }
    },
    methods: {
        goback() {
            let r = this.$route.path.split('/')
            r.pop()
            let nr = r.length > 1 ? r.join('/') : '/'
            if (nr == `/${this.key}/` || nr == `/${this.key}`)
                this.$router.push('/')
            else 
                this.$router.push(nr)
        },
        checkkey() {
        axios.get(`api/scoring/keycheck/${this.$route.params.key}`)
            .then(({ data }) => {
                this.reg = data.allowCompetitorReg
                this.id = data.competitionId
                this.found=true,
                this.compname= data.competitionName
            })
            .catch(() => {
                this.reg = false
                this.found = false
                //throw error
            })
            .finally(() => {
                this.key = this.$route.params.key
                this.loadingcheck = false
            })    

        }
    },
    props: {  }
}
</script>

<style>
.has-navbar-fixed-top { padding: 0 !important; }
.competing-main {
    height: calc(100vh - 3.75rem);
    overflow: hidden;
}
.score-board-page .columns { margin: initial; }
.scoring-h2 { font-size: 1.5rem; font-weight: 600; padding: .75rem 0; }
.white-back { background: #fff; }
.shift-row { display: flex; margin-top: 2.75rem; }
.button.shift-right { margin-left: .375rem;  }
.register-email .help.is-danger { position: absolute; width: 100%; text-align: right; }

.slide-enter-active, .slide-leave-active {

}
.pad-some { padding: 2rem 1rem; }
.left .slide-enter, .right .slide-leave-to {
  transform: translate(100%, 0);
}
.left .slide-leave-to, .right .slide-enter {
  transform: translate(-100%, 0);
}
.slide-leave-active, .slide-enter-active {
    transition: transform 500ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
}
.pad-fix, .pad-fix.columns:last-child { margin-top: 3.25rem; }
</style>
